import { withTheme } from '@material-ui/core';
import React from 'react';

export default withTheme()(({ vertical, large, theme }) => (
    <div>
        <div style={{
            [vertical ? 'height' : 'width']: (large ? theme.spacing.unit * 4 : theme.spacing.unit * 2)
        }} />
    </div>
))


// WEBPACK FOOTER //
// ./src/components/common/Spacing.js